import apiClient from 'utilities/api-client';

export const fetchServiceAgreements = async (request: { customerId: string }) =>
  await apiClient.get(`api/portal/customers/${request.customerId}/service-agreements`, request);

export const fetchServiceAgreement = async (request: { customerId: string; serviceAgreementId: string }) =>
  await apiClient.get(`api/portal/customers/${request.customerId}/service-agreements/${request.serviceAgreementId}`);
